<h2 class="first_title">Anteprima Documento</h2>
<div class="content-page-wrapper">
    <div class="standardpanel">
        <div class="row">
            <div class="col-sm-12" style="margin-bottom: 30px;">
                <nav aria-label="Navigazione contenuti" *ngIf="breadCrumb.length > 1">
                <ol class="breadcrumb">
                    <li *ngFor="let item of breadCrumb; let i = index; let last = last" class="breadcrumb-item" [class.active]="i === activeIndex">
                        <a href="javascript:void(0)" [attr.aria-label]="'vai a ' + truncate(item.subject, 10)" (click)="grabState(i)">{{ truncate(item.subject, 10) }}</a>
                    </li>
                </ol>
                </nav>
            </div>
        </div>
        <div *ngIf="!!email; else noPreview">
           <div><strong>Oggetto: </strong>{{email?.subject}}</div>
           <div><strong>Data: </strong>{{email?.date | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
           <div><strong>Mittente: </strong> {{ email?.from?.address }}</div>
           <div><strong>Destinatari: </strong> {{ getConcatenatedAddresses(email?.to, "address") }}</div>
       
           <hr>
       
           <div *ngIf="email.attachments && email.attachments.length > 0">
               <strong>Allegati: </strong><br>
               <ul>
                   <li class="" *ngFor="let attachment of email.attachments">
                        <!-- <span class="glyphicon glyphicon-file"></span>
                        <a *ngIf="canViewFile(attachment)" href="javascript:void(0)" alt="Apri anteprima allegato" (click)="openAttachmentPreview(attachment)">
                            {{attachment.description || attachment.filename}}
                        </a>   
                        <span *ngIf="!canViewFile(attachment)" class="glyphicon glyphicon-eye-open" (click)="openAttachmentPreview(attachment)"></span> -->
                        <span class="glyphicon glyphicon-file"></span>
                        <span>
                            {{attachment.description || attachment.filename}}
                        </span>   
                        <a *ngIf="canViewFile(attachment)" href="javascript:void(0)" [attr.aria-label]="'Apri anteprima allegato ' + (attachment.description || attachment.filename)" (click)="openAttachmentPreview(attachment)">
                            <span class="glyphicon glyphicon-eye-open"></span>
                        </a>
                        <span 
                            *ngIf="!canViewFile(attachment)" 
                            class="glyphicon glyphicon-eye-close"
                            [appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'" 
                            [appTooltipEnabled]="attachment.maxLimitExceeded">
                        </span>
                    </li>
               </ul>
           </div>
       
           <hr>
       
           <div>
               <strong>Testo: </strong><br>
               <div [innerHTML]="rendereBodyText(email.text ?? email.html)"></div>
           </div>
        </div>
        <ng-template #noPreview>
            <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4 preview-wrapper">
                    <h4>Anteprima non disponibile, si prega di tornare alla home</h4>
                    <button style="max-width: 200px;margin: 0 auto;" [routerLink]="['/']" class="btn btn-primary btn-block">Vai alla home</button>
                </div>
                <div class="col-sm-4"></div>
            </div>
        </ng-template>
        <app-spinner></app-spinner>

    </div>
</div>
